/**
 * Centralized chain-node configuration for the wallet.
 *
 * Mirrors apps/web/nginx.conf (which is the production source of truth):
 *   primary  = http://node1.gonka.ai:8000/chain-api/
 *   fallback = https://node.gonkahub.com/cosmos/
 *
 * When the user selects "Pick from list" in Settings → Network, they
 * pick one of these preset nodes by `id`. The wallet then talks
 * directly to the chosen node (not through the same-origin nginx
 * reverse proxy).
 */

export interface PresetNode {
  /** Stable id persisted in IndexedDB. Never rename — migration cost. */
  readonly id: string;
  /** Short human label, NOT localized — chain node names are universal. */
  readonly label: string;
  /** Full URL including scheme and port (no trailing slash, no path). */
  readonly url: string;
}

export const PRESET_NODES: readonly PresetNode[] = [
  { id: 'gonka-node-1', label: 'Gonka Node 1', url: 'http://node1.gonka.ai:8000' },
  { id: 'gonka-node-2', label: 'Gonka Node 2', url: 'http://node2.gonka.ai:8000' },
  { id: 'gonkahub',     label: 'Gonkahub',     url: 'https://node.gonkahub.com' },
  { id: 'gonka-spv',    label: 'Gonka SPV',    url: 'https://gonka.spv.re' },
];

/** What's actually behind `'gonka-hub'` (default same-origin /api/chain/ reverse proxy). */
export const DEFAULT_NODE_URLS = {
  primary: 'http://node1.gonka.ai:8000',
  fallback: 'https://node.gonkahub.com',
} as const;

export function findPresetNode(id: string | null | undefined): PresetNode | undefined {
  if (id == null) return undefined;
  return PRESET_NODES.find((p) => p.id === id);
}
